import React, { useEffect } from "react";
import AllChicken from "../Chicken/AllChicken";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";

const ChickenM = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <AllChicken />
      <Footer />
    </>
  );
};

export default ChickenM;
